<template>
  <div class="availability" v-if="showAvailability">
    <div class="availability-head">
      <span class="white-title">Availability</span>
    </div>
    <div class="table-container" role="table" aria-label="Destinations">
      <div class="flex-table header" role="rowgroup">
        <div class="flex-row first" role="columnheader">Unit</div>
        <div class="flex-row" role="columnheader">Bedroom</div>
        <div class="flex-row" role="columnheader">Bathroom</div>
        <div class="flex-row" role="columnheader">Int.SqFt</div>
        <div class="flex-row" role="columnheader">Ext.SqFt</div>
        <div class="flex-row" role="columnheader">Unit Price</div>
        <div class="flex-row flex-row-mobile" role="columnheader">RE Tax</div>
        <div class="flex-row flex-row-mobile" role="columnheader">CC</div>
        <div class="flex-row flex-row-mobile" role="columnheader">Floorplan</div>
      </div>
      <div class="flex-table row" role="rowgroup" v-for="unit in units" :key="unit.id"  @click.stop="openDocument(unit.floorplan)">
        <div class="flex-row first" role="cell"><span class="flag-icon flag-icon-gb"></span>{{ unit.name }}</div>
        <div class="flex-row" role="cell">{{ unit.bedroom }}</div>
        <div class="flex-row" role="cell">{{ unit.bathroom }}</div>
        <div class="flex-row" role="cell">{{ unit.int_sqft }}</div>
        <div class="flex-row" role="cell">{{ unit.ext_sqft }}</div>
        <div class="flex-row" role="cell">{{ unit.price }}</div>
        <div class="flex-row flex-row-mobile" role="cell">{{ unit.tax }}</div>
        <div class="flex-row flex-row-mobile" role="cell">{{ unit.cc }}</div>
        <div class="flex-row flex-row-mobile" role="cell">
            <a class="flex-row-download" :href="unit.floorplan" target="_blank">
                Download
            </a>
        </div>
    </div>
  </div>
  </div>
</template>

<script>
  export default {
    name: "Availability",
    data: () => ({
        units: [],
        showAvailability: false
    }),
    created() {
        this.fetchData();
    },
    methods: {
        fetchData() {
            fetch('/units')
                .then((response) => response.json())
                .then((data) => {
                    this.units = data
                    this.showAvailability = true
                });
        },

        openDocument(floorplan) {
            if(window.innerWidth < 600) {
                window.open(floorplan, '_blank')
                return;
            }
        }
    }
  }
</script>

<style scoped>

</style>
